export default "__VITE_ASSET__DcnUc2Ri__"